<template>
    <div class="web">
        <Header :type="'nosotros'"></Header>
        <main class="nosotros">
            <!-- CONTENT 2 -->
            <div class="container-top" :style="{ 'background': ' linear-gradient(0deg, rgba(255, 255, 255, 0.35), rgba(255, 255, 255, 0.35)), center / 34% 90% no-repeat url('+ urlWeb +'/assets/images/fotos/40.jpg)'}">
                <div class="d-flex container-top">
                    <div class="d-flex flex-column align-items-start">
                        <h2 class="strong text-grey mb-4 text-center">Cosas importantes a <span
                                class="text-light-grey bg-blue px-3">tener
                                en</span> cuenta</h2>

                        <p class=" font-medium">Si tu Empresa utiliza alguna de las soluciones de SAP y necesitas de
                            consultores expertos para
                            ejecutar tus proyectos.</p>
                        <p class="font-medium">O si eres un Consultor SAP independiente buscando nuevas oportunidades.</p>

                        <h2 class="text-grey text-center ml-5">it<span class="text-orange">SAP</span>p</h2>

                        <p class="font-medium mb-3">es la plataforma de servicios online que estás buscando.</p>

                        <img class="img-fluid mb-3" :src="urlWeb + '/assets/images/fotos/asset02.png'"
                            alt="Nuestro objetivo principal Lograr la satisfacción del cliente">

                        <p class="font-medium">Mejorando los sistemas de software integrado de SAP que se encuentran comúnmente en sus
                            escritorios.</p>
                    </div>
                    <div class=""></div>
                    <div class="right-side d-flex flex-column align-items-end justify-content-center">
                        <p class="quote mb-5">“Los humanos crean tecnología, y la tecnología ayuda más a los humanos”</p>

                        <p class="mb-5 font-medium"><span class="text-orange strong">¡Únete</span> hoy mismo a nuestra
                            comunidad y descubre cómo podemos ayudarte a alcanzar tus objetivos!</p>

                        <router-link to="/Registro" class="btn btn-lg btn-subscribe">Suscríbete</router-link>
                    </div>
                </div>
            </div>

            <!-- SEPARADOR DOS COLORES -->
            <div class="container">
                <hr>
            </div>

            <!-- VIDEO 1 -->
            <div class="container">
                <video controls>
                    <source :src="urlWeb + '/assets/videos/Que nos caracteriza.mp4'" type="video/mp4">
                    <em>Tu Navegador no soporta la reproducción de videos incrustados</em>
                </video>
            </div>

            <div class="container my-5 text-center container-bottom">
                <h2 class="text-grey text-center strong mb-5">Descubre las ventajas que it<span
                        class="text-orange">SAP</span>p puede ofrecerte, y lleva a tu empresa al siguiente nivel de
                    innovación y rentabilidad</h2>

                <router-link to="/Registro" class="btn btn-subscribe-lg mb-5">Suscríbete</router-link>
            </div>
        </main>
    </div>
  </template>
    
    <script>
    import { mapState } from 'vuex'
    import Header from '@/components/Header'
    export default {
      computed:{
        ...mapState(['urlWeb'])
    },
      name: 'Nosotros',
      components:{
        Header
    },
      data () {
        return {
        }
      }
    }
    </script>


// WEBPACK FOOTER //
// src/views/Home/Nosotros.vue